import { render } from "./Hints.vue?vue&type=template&id=2c52acf1"
import script from "./Hints.vue?vue&type=script&lang=js"
export * from "./Hints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__